import { render, staticRenderFns } from "./otherNation.vue?vue&type=template&id=f96bd378&scoped=true"
import script from "./otherNation.vue?vue&type=script&lang=js"
export * from "./otherNation.vue?vue&type=script&lang=js"
import style0 from "./otherNation.vue?vue&type=style&index=0&id=f96bd378&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96bd378",
  null
  
)

export default component.exports